import AddBottomSpace from "../../components/AddBottomSpace";
import AddHeadline from "../../components/AddHeadline";
import AddTopSpace from "../../components/AddTopSpace";
import CarouselHome from "../../components/CarouselHome";
import CuttingAcrossBanner from "../../components/CuttingAcrossBanner";
import TransversalEcoBanner from "../../components/TransversalEcoBanner";
 
export default function Home() {

  return (
    <>
      <AddTopSpace />
      <AddHeadline />
      <TransversalEcoBanner />
      <CuttingAcrossBanner />
      <div className="container py-3">

        <div className='row'>
          <div className='col d-flex justify-content-center'>
            <CarouselHome />
          </div>
        </div>
      </div>
      
      <AddBottomSpace />
      <AddBottomSpace />
    </>
  )
}
